import moment from 'moment'
import api, { getSummaryInfoForJob } from '../../api'

import { getDefaultRange } from '../../utils/dateHelper'

const jobMapper = ({
                     UUID,
                     dealer,
                     name,
                     scheduledStartTime,
                     status,
                     countAssignedUsers,
                     completedTime,
                     startedTime,
                     notes,
                   }) => {
  return {
    UUID,
    dealer: dealer.name,
    autoMake: dealer.brand,
    name,
    scheduledStartTime: scheduledStartTime.split(' +')[0],
    status,
    dealerUUID: dealer.UUID,
    countAssignedUsers,
    completedTime,
    startedTime,
    lastSnapshotTime: dealer.lastSnapshotTimeString,
    notes,
  }
}

export const fetchVarianceData = (UUID) => async (dispatch) => {
  try {
    const response = await api.getVarianceCheckingPendingPartnumBin(UUID)
    dispatch({
      type: 'FETCH_VARIANCE_DATA',
      payload: response,
    })
    // api.getVarianceCheckingPendingPartnumBin(props.job.UUID),


    return response
  } catch (e) {
    console.error(e)
  }
}


export const fetchVarianceCheckingUserAssignments = (UUID) => async (dispatch) => {
  try {
    const responce = await api.getVarianceCheckingUserAssignments(UUID)
    dispatch({
      type: 'FETCH_VARIANCE_CHECKING_USER_ASSIGNMENTS',
      payload: responce.data,
    })

    return responce

  } catch (e) {
    console.error(e)
  }
}

export const fetchVarianceCheckingPartNumBin = (UUID) => async (dispatch) => {
  try {
    const responce = await api.getVarianceCheckingPendingPartnumBin(UUID)
    dispatch({
      type: 'FETCH_VARIANCE_CHECKING_PART_NUM_BIN',
      payload: responce.data,
    })

    return responce

  } catch (e) {
    console.error(e)
  }
}


export const fetchJobs = () => async (dispatch) => {
  try {
    const response = await api.fetchJobs()
    dispatch({
      type: 'FETCH_JOBS',
      payload: response.data.data.map((job) => jobMapper(job)),
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const updateJobStatus = (id, status) => async (dispatch) => {
  await api.updateJobStatus(id, status)
  dispatch({
    type: 'UPDATE_JOB_STATUS',
    payload: { id, status },
  })
}

export const addJobFilter = (prop, value) => {
  return {
    type: 'ADD_JOB_FILTER',
    payload: { prop, value },
  }
}

export const addStatusFilter = (prop, value) => {
  return {
    type: 'ADD_STATUS_FILTER',
    payload: { prop, value },
  }
}

export const removeStatusFilter = (prop, value) => {
  return {
    type: 'REMOVE_STATUS_FILTER',
    payload: { prop, value },
  }
}


export const addJobSort = (prop, isDesc) => {
  return {
    type: 'ADD_JOB_SORT',
    payload: { prop, isDesc },
  }
}

export const addDealerSort = (prop, isDesc) => {
  return {
    type: 'ADD_DEALER_SORT',
    payload: { prop, isDesc },
  }
}

export const addEmployeeSort = (prop, isDesc) => {
  return {
    type: 'ADD_EMPLOYEE_SORT',
    payload: { prop, isDesc },
  }
}

export const clearJobFilter = () => {
  return {
    type: 'CLEAR_JOB_FILTER',
  }
}

export const removeJobFilter = (prop) => {
  return {
    type: 'REMOVE_JOB_FILTER',
    payload: { prop },
  }
}

export const clearJobSort = () => {
  return {
    type: 'CLEAR_JOB_SORT',
  }
}

export const changeDaterange = (daterange) => async (dispatch) => {
  try {
    const response = await api.fetchJobs(
      daterange.startDate,
      daterange.endDate,
    )
    dispatch({
      type: 'CHANGE_DATE_RANGE',
      payload: {
        jobList: response.data.data.map((job) => jobMapper(job)),
        daterange: daterange,
      },
    })
  } catch (e) {
    console.error(e)
  }
}

export const clearDaterange = () => async (dispatch) => {
  const daterange = getDefaultRange()
  try {
    const response = await api.fetchJobs(daterange)
    dispatch({
      type: 'CLEAR_DATE_RANGE',
      payload: {
        jobList: response.data.data.map((job) => jobMapper(job)),
        daterange: daterange,
      },
    })
  } catch (e) {
    console.error(e)
  }
}

export const createNewJob = (newJob, callback) => async (dispatch) => {
  try {
    const newJobBody = {
      name: newJob.name,
      status: newJob.status,
      dealerUUID: newJob.dealerUUID,
      scheduledStartTime: moment
        .utc(newJob.scheduledStartTime, 'MM/DD/YYYY h:mm a')
        .format('YYYY-MM-DD HH:mm:ss'),
      notes: newJob.notes,
    }
    const response = await api.createNewJob(newJobBody)
    const jobData = await api.fetchJobById(response.data.data.UUID)
    dispatch({
      type: 'CREATE_NEW_JOB',
      payload: {
        ...newJob,
        UUID: response.data.data.UUID,
        name: jobData.data.data.name,
        dealer: newJob.dealer,
        dealerUUID: newJob.dealerUUID,
        autoMake: newJob.autoMake,
        countAssignedUsers: 0,
        scheduledStartTime: moment
          .utc(newJob.scheduledStartTime, 'MM/DD/YYYY h:mm a')
          .format('YYYY-MM-DD HH:mm:ss'),
      },
    })
    callback(response.data.data.UUID)
  } catch (e) {
    console.error(e)
  }
}

export const createNewDealer = (newDealer, callback) => async (dispatch) => {
  try {
    const response = await api.createNewDealer(newDealer)
    dispatch({
      type: 'CREATE_NEW_DEALER',
      payload: {
        ...newDealer,
        UUID: response.data.data.UUID,
        status: 'active',
      },
    })
    callback(response.data.data.UUID)
  } catch (e) {
    console.error(e)
    //eslint-disable-next-line
    throw { inputName: 'name', message: 'This name is already in use' }
  }
}

export const fetchDealers = () => async (dispatch) => {
  try {
    const response = await api.fetchDealers()
    dispatch({
      type: 'FETCH_DEALERS',
      payload: response.data.data,
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const fetchDealersBySearchTerm = (searchTerm) => async (dispatch) => {
  try {
    const response = await api.fetchDealersBySearchTerm(searchTerm)
    dispatch({
      type: 'ADD_DEALER_SEARCH',
      payload: {
        searchTerm,
        searchedDealerList: response.data.data,
      },
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const clearDealerSearch = () => {
  return {
    type: 'CLEAR_DEALER_SEARCH',
  }
}

export const deleteDealer = (dealer, reason, callback) => async (dispatch) => {
  try {
    await api.deleteDealer(dealer, reason)
    callback()
    dispatch({
      type: 'DELETE_DEALER',
      payload: dealer,
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const getJobsByDealer = (dealer) => async (dispatch) => {
  try {
    const result = await api.getJobsByDealer(dealer)
    dispatch({
      type: 'FETCH_JOBS_BY_DEALER',
      payload: {
        dealerId: dealer.UUID,
        jobs: result.data.data,
      },
    })
  } catch (e) {
    console.error(e)
  }
}

export const updateJob = (job, id) => async (dispatch) => {
  try {
    await api.updateJob(job, id)
    dispatch({
      type: 'UPDATE_JOB',
      payload: { job, id },
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const fetchJobById = (id) => async (dispatch) => {
  try {
    const response = await api.fetchJobById(id)
    dispatch({
      type: 'ADD_SINGLE_JOB',
      payload: jobMapper(response.data.data),
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const updateDealer = (dealer, id) => async (dispatch) => {
  try {
    const response = await api.updateDealer(dealer, id)
    dispatch({
      type: 'UPDATE_DEALER',
      payload: { dealer, id },
    })
    return response
  } catch (e) {
    //eslint-disable-next-line
    throw { message: 'This name is already in use' }
  }
}

export const fetchAllEmployees = () => async (dispatch) => {
  try {
    const promise = api.fetchEmployees()
    dispatch({
      type: 'FETCH_EMPLOYEES_LOADING',
      payload: promise,
    })
    const response = await promise
    dispatch({
      type: 'FETCH_EMPLOYEES',
      payload: response.data.data,
    })
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

export const createNewEmployee = (newEmployee, onSuccess) => async (
  dispatch,
) => {
  try {
    const response = await api.createNewEmployee(newEmployee)
    dispatch({
      type: 'CREATE_NEW_EMPLOYEE',
      payload: {
        ...newEmployee,
        UUID: response.data.data.UUID,
      },
    })
    onSuccess(response.data.data.UUID)
  } catch (e) {
    console.error(e)
    //eslint-disable-next-line
    throw { inputName: 'email', message: 'This email is already in use' }
  }
}

export const fetchEmployeesBySearchTerm = (searchTerm) => async (dispatch) => {
  try {
    const response = await api.fetchEmployeesBySearchTerm(searchTerm)
    dispatch({
      type: 'ADD_EMPLOYEE_SEARCH',
      payload: {
        searchTerm,
        searchedEmployeeList: response.data.data,
      },
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const clearEmployeeSearch = () => {
  return {
    type: 'CLEAR_EMPLOYEE_SEARCH',
  }
}

export const deleteEmployee = (employee, reason, callback) => async (
  dispatch,
) => {
  try {
    await api.deleteEmployee(employee, reason)
    callback()
    dispatch({
      type: 'DELETE_EMPLOYEE',
      payload: employee,
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const getJobsByEmployee = (employee) => async (dispatch) => {
  try {
    const result = await api.getJobsByEmployee(employee)
    dispatch({
      type: 'FETCH_JOBS_BY_EMPLOYEE',
      payload: {
        employeeId: employee.UUID,
        jobs: result.data.data.map((job) => ({
          ...job,
          dealer: job.dealer.name,
        })),
      },
    })
  } catch (e) {
    console.error(e)
  }
}

export const updateUserEmail = (id, email) => async (dispatch) => {
  try {
    const response = await api.updateUserEmail(id, email)
    dispatch({
      type: 'UPDATE_USER',
      payload: { id, data: { email } },
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const updateUserStatus = (id, status) => async (dispatch) => {
  try {
    await api.updateUserStatus(id, status)
    dispatch({
      type: 'UPDATE_USER',
      payload: { id, data: { status } },
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const updateUserRole = (id, role) => async (dispatch) => {
  try {
    await api.updateUserRole(id, role)
    dispatch({
      type: 'UPDATE_USER',
      payload: { id, data: { role } },
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const updateUserData = (id, user) => async (dispatch) => {
  try {
    const response = await api.updateUserData(id, user)
    dispatch({
      type: 'UPDATE_USER',
      payload: { id, data: { ...user } },
    })
    return response
  } catch (e) {
    console.error(e)
  }
}

export const addNewUser = (user) => async (dispatch) => {
  try {
    const response = await api.addNewUser(user)
    dispatch({
      type: 'ADD_NEW_USER',
      payload: { UUID: response.data.data.UUID, ...user },
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const addOrRemoveUser = (id, isAddUser) => {
  return {
    type: 'ADD_OR_REMOVE_EMPLOYEE',
    payload: {
      id,
      isAddUser,
    },
  }
}

export const fetchPrintData = (printData) => {
  return {
    type: 'FETCH_PRINT_DATA',
    payload: {
      printData,

    },
  }
}

export const fetchPrintSelected = (printSelected) => {
  return {
    type: 'FETCH_PRINT_SELECTED',
    payload: {
      printSelected,
    },
  }
}

export const showAccepted = (show) => {
  console.log('showAccepted action')
  return {
    type: 'SHOW_ACCEPTED',
    payload: {
      show,
    },
  }
}

export const rerender = (render) => {
  return {
    type: 'RERENDER',
    payload: {
      render,
    },
  }
}

export const getValue = (value) => {
  return {
    type: 'GET_VALUE',
    payload: {
      value,
    },
  }
}

export const setPriceFilterValue = (value) => {
  return {
    type: 'SET_PRICE_FILTER_VALUE',
    payload: {
      value,
    },
  }
}



export const ClearValue = (clearValue) => {

  return {
    type: 'CLEAR_VALUE',
    payload: {
      clearValue,
    },
  }
}
export const isModalOpen = (open) => {
  return {
    type: 'IS_MODAL_OPEN',
    payload: {
      open,
    },
  }
}
export const setNewRun = (newRun) => {
  return {
    type: 'SET_NEW_RUN',
    payload: {
      newRun,
    },
  }
}
export const getOrders = (orders) => {
  return {
    type: 'GET_ORDERS',
    payload: {
      orders,
    },

  }
}

export const redirectToVariance = (redirect) => {
  return {
    type: 'REDIRECT_TO_VARIANCE',
    payload: {
      redirect,
    },
  }
}
export const getFinalRun = (finalRun) => {
  return {
    type: 'GET_FINAL_RUN',
    payload: {
      finalRun,
    },
  }


}
export const getOrderss = (jobId) => async (dispatch) => {
  try {
    const response = await getSummaryInfoForJob(jobId)
    dispatch({
      type: 'GET_ORDERSS',
      payload: { data: response.data },
    })
    return
  } catch (e) {
    console.error(e)
  }
}

export const getPendingTasks = (jobId) => async (dispatch) => {
  try {
    const response = await api.getPendingTasks(jobId)
    dispatch({
      type: 'GET_PENDING_TASKS',
      payload: { data: response.data.data },
    })
  } catch (e) {
    console.error(e)
  }
}


export const getPartsAction = (id) => async (dispatch) => {
  try {
    const response = await api.getPartnumData(id)
    console.log('response' ,response.data)
    dispatch({
      type: 'GET_PARTS',
      payload: response.data
    })
    return response.data
  } catch (e) {
    console.error(e)
  }
}

export const getStatusOfDMS = (jobId) => async (dispatch) => {
  try {
    const response = await api.getDataFromDms(jobId)
    dispatch({
      type: 'GET_STATUS_OF_DMS',
      payload: { data: response.data.data.status },

    })
  } catch (e) {
    console.error(e)
  }
}
export const clearStatusOfDMS = () => {
  return {
    type: 'CLEAR_STATUS_OF_DMS',
  }
}

export const setCompletedRun = (completed) => {
  return {
    type: 'SET_COMPLETED_RUN',
    payload: {
      completed,
    },
  }
}
export const setNewVariance = (variance) => {
  return {
    type: 'SET_NEW_VARIANCE',
    payload: {
      variance,
    },
  }
}


export const setReports = () => async (dispatch) => {
    try {
      const response = await api.getAvailableReports()
      dispatch({
        type: 'FETCH_REPORTS',
        payload: response.data.data
      })
    } catch (e){
      console.log(e)
    }
}

export const setReportsToJob = (reportName, params) => async (dispatch) => {
  try {
    const response = await api.pushToReports(reportName, params)
    console.log(response)
    dispatch({
      type: 'FETCH_REPORTS_JOB',
      payload: response.data.data
    })
  } catch (e){
    console.log(e)
  }
}

export const setReportsToDealers = (reportName, params) => async (dispatch) => {
  try {
    const response = await api.pushToReports(reportName, params)
    console.log({ response })
    dispatch({
      type: 'FETCH_REPORTS_DEALERS',
      payload: response.data.data
    })
  } catch (e){
    console.log(e)
  }
}

export const setReportsToEmployees = (reportName, params) => async (dispatch) => {
  try {
    const response = await api.pushToReports(reportName, params)
    console.log({ response })
    dispatch({
      type: 'FETCH_REPORTS_USERS',
      payload: response.data.data
    })
  } catch (e){
    console.log(e)
  }
}

